"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  dangerouslySetInnerHTML: {
    __html: "<path d=\"M12 14.233L14.781 16l-.738-3.33 2.457-2.24-3.236-.294L12 7l-1.264 3.136-3.236.294 2.453 2.24L9.219 16 12 14.233z\" fill=\"#000\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 4v6a2 2 0 110 4v6h20v-6a2 2 0 110-4V4H2zm4 8c0-1.48-.804-2.773-2-3.465V6h16v2.535A3.998 3.998 0 0018 12c0 1.48.804 2.773 2 3.465V18H4v-2.535A3.998 3.998 0 006 12z\" fill=\"#000\"></path>"
  },
  viewBox: "0 0 24 24",
  fill: "none"
};
exports["default"] = _default;